module.exports = __webpack_public_path__ + "static/media/Illumina_light.030a3871.png";